import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useAppStateHeaderSelector } from '../../../components/header/headerSlice';
import { loadLanguageOptions } from '../../../components/header/headerActionCreators';
import styles from './LanguagesList.module.scss';
import { PanelRow } from '../../../components/panel/PanelRow';
import { Panel } from '../../../components/panel/Panel';
import { PageContainer } from '../../../components/pageContainer/PageContainer';
import { Spinner } from '../../../components/spinner/Spinner';

// Helper function to extract English name from language text
// Language text format is "Native Name (English Name)" e.g. "Español (Spanish)"
const getEnglishName = (languageText: string): string => {
    const match = languageText.match(/\(([^)]+)\)$/);
    return match ? match[1] : languageText;
};

export const LanguagesList = () => {
    const dispatch = useDispatch();
    const { languageOptions } = useAppStateHeaderSelector((state) => state);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const loadLanguages = async () => {
            setIsLoading(true);
            await dispatch(loadLanguageOptions());
            setIsLoading(false);
        };
        
        // Only load if language options are empty
        if (languageOptions.length === 0) {
            loadLanguages();
        } else {
            setIsLoading(false);
        }
    }, [dispatch, languageOptions.length]);

    const LanguageListings = languageOptions.map((language: any) => {
        const englishName = getEnglishName(language.text);
        return (
            <div className="listItemColor" key={language.value}>
                <Link to={`/languages/${language.value}`} style={{color: 'inherit'}}>
                    <div className={styles.list_item}>
                    <div className={styles.item_text}>
                        {englishName}
                    </div>
                    </div>
                </Link>
            </div>
        )
    });

    return (
        <PageContainer>
            <h2>Language Management</h2>
            <PanelRow>
                <Panel>
                    <div className='headerContainer'>
                        <h3>Languages</h3>
                    </div>
                    <div className={styles.listing_table}>
                        {isLoading ? (
                            <div style={{ textAlign: 'center', padding: '20px' }}>
                                <Spinner isLoading={true} />
                            </div>
                        ) : (
                            LanguageListings
                        )}
                    </div>
                </Panel>
            </PanelRow>
        </PageContainer>
    );
};
